<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<nz-spin [nzSpinning]="loading$ | async">
  <div class="drawer-form-wrapper without-bottom-cta">
    <div class="behaviour-card-sec">
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{
            caseParams.case?.student?.firstName +
              ' ' +
              caseParams.case?.student?.lastName
          }}
        </h3>
      </div>
      <div class="card-content-wrapper">
        <div class="content">
          <h4 class="title">Date Of Birth</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-calendar.svg"
              class="icon s-16"
              aria-label="Calendar"></svg-icon>
            {{
              caseParams.case?.student?.dateOfBirth ?? null | date: 'MM/dd/yyyy'
            }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Supervisor</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-supervisor.svg"
              class="icon s-16"
              aria-label="Supervisor"></svg-icon>
            {{ caseParams.case?.supervisorName }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Gender</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-male.svg"
              class="icon s-16"
              aria-label="Male"></svg-icon>
            {{ caseParams.case?.student?.gender }}
          </p>
        </div>
      </div>
    </div>
    <div class="header-with-cta without-border">
      <h3 class="title s-18">Current Team Members</h3>
      <div class="cta-wrapper">
        <app-search-input
          placeholder="Search case members"
          [debounceTime]="1000"
          (searchChange)="handleSearch($event)">
        </app-search-input>
        <button nz-button nzType="primary" (click)="openAddTeamMember()">
          Add Team Member
        </button>
      </div>
    </div>
    <nz-table
      #sortTable
      [nzData]="(caseMemberList$ | async) ?? []"
      nzTableLayout="fixed"
      [nzScroll]="{ x: '900' }"
      [nzTotal]="totalRows"
      [nzFrontPagination]="false"
      [(nzPageIndex)]="pageIndex"
      [nzPageSize]="pageSize"
      (nzQueryParams)="onQueryParamsChange($event)">
      <thead>
        <tr>
          <th
            scope="col"
            nzWidth="150px"
            [nzSortFn]="true"
            [title]="listOfColumn[0].title"
            [nzColumnKey]="listOfColumn[0].key">
            {{ listOfColumn[0].title }}
          </th>
          <th
            scope="col"
            nzWidth="300px"
            [title]="listOfColumn[1].title"
            [nzColumnKey]="listOfColumn[1].key">
            {{ listOfColumn[1].title }}
          </th>
          <th
            scope="col"
            nzWidth="100px"
            [title]="listOfColumn[2].title"
            [nzColumnKey]="listOfColumn[2].key">
            {{ listOfColumn[2].title }}
          </th>
          <th scope="col" nzRight nzWidth="70px">
            {{ listOfColumn[3].title }}
          </th>
        </tr>
      </thead>
      <tbody>
        @for (data of sortTable.data; track data.id) {
          <tr>
            <td [title]="data.caseMemberName">
              {{ data.caseMemberName }}
            </td>
            <td [title]="data.organizationName || '-'">
              {{ data.organizationName || '-' }}
            </td>
            <td>
              <label
                nz-radio
                [(ngModel)]="data.isSupervisor"
                (click)="!data.isSupervisor && onUpdateMember(data)"
                (keydown.enter)="!data.isSupervisor && onUpdateMember(data)"
                tabindex="0"></label>
            </td>
            <td>
              <div class="action-btn-wrapper">
                <button
                  nz-button
                  nzType="text"
                  (click)="onDeleteMember(data.id)"
                  tabindex="0">
                  <svg-icon
                    src="/assets/icon/icon-trash.svg"
                    class="icon s-20"
                    aria-label="Trash">
                  </svg-icon>
                </button>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
</nz-spin>

<app-confirm-dialog
  [isVisible]="showConfirmDialog"
  [title]="'Delete Member'"
  [message]="confrimDialogMsg"
  [iconSrc]="'/assets/icon/icon-trash-red.svg'"
  [iconColor]="'red'"
  [cancelText]="'Cancel'"
  [confirmText]="'Delete'"
  [loading]="isDeleting"
  (confirmed)="handleDelete()"
  (cancelled)="handleCancel()"
  (closed)="handleCancel()">
</app-confirm-dialog>

<ng-template #addTeamMemberDrawerTitleTpl>
  <app-drawer-header
    [title]="'Add Team Member'"
    [breadcrumbText]="getStudentFullName()"
    [subtitle]="'Manage Student Team'"
    (drawerClose)="closeAddTeamMemberDrawer()">
  </app-drawer-header>
</ng-template>
